
import {
  computed,
  defineComponent, onMounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form } from 'vee-validate';
import AppSelect from '@/components/UI/AppSelect.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { useRegistrationStore } from '../store/registrationStore';
import AppLoader from '@/components/UI/AppLoader.vue';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import { HEALTHCARE } from '@/types/enums';

export default defineComponent({
  components: {
    Form,
    AppSelect,
    AppButton,
    AppLoader,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const dataRequest = ref(true);
    const professionValue = ref(registrationStore.createUser.profession);

    const skipNpiUrl = computed(() => {
      if (professionValue.value === HEALTHCARE.OTHER) {
        return 'step-3a';
      }
      if (professionValue.value === HEALTHCARE.NURSING) {
        return 'step-3b';
      }
      if (professionValue.value === HEALTHCARE.ALLIED_HEALTH) {
        return 'step-3c';
      }
      if (professionValue.value === HEALTHCARE.DENTAL) {
        return 'step-3d';
      }
      if (professionValue.value === HEALTHCARE.MEDICAL) {
        return 'step-3e';
      }
      return 'step-7';
    });

    function nextStep() {
      registrationStore.createUser.profession = professionValue.value;
      if (professionValue.value === HEALTHCARE.OTHER) {
        router.push('step-3a');
      } else if (professionValue.value === HEALTHCARE.VETERINARY) {
        router.push('step-7');
      } else if (registrationStore.createUser.countryCode !== 'US') {
        router.push(skipNpiUrl.value);
      } else {
        router.push('step-4');
      }
    }

    function getHealthcareData() {
      mainStore.fetchHealthcare().finally(() => { dataRequest.value = false; });
    }

    function changeProfession() {
      registrationStore.createUser.professionType = undefined;
      registrationStore.createUser.professionSpeciality = undefined;
    }

    onMounted(() => {
      if (!registrationStore.searchUser.firstName) {
        router.push('healthcare');
      }
      getHealthcareData();
      MonitoringService.sendPageMountedSpeed();
    });

    const showHippaStorageLable = registrationStore.createUser.countryCode === 'US' && registrationStore.createUser.hippa;

    return {
      nextStep,
      dataRequest,
      professionValue,
      mainStore,
      changeProfession,
      showHippaStorageLable,
    };
  },
});
